import { createSelector } from 'reselect';

import type { RootState } from 'typesafe-actions';
import type { PitariState } from './reducer';

export const getPitari = (state: RootState) => state.pitari;

export const getIsFetching = createSelector(getPitari, (state: PitariState) => state.isFetching);
export const getItem = createSelector(getPitari, (state: PitariState) => state.item);
